import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { data } from 'jquery';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environments/environment';

export const SERVER_API_URL = environment.serverUrl;
const routes = {
  mypr: {
    getAllItem: () => `${SERVER_API_URL}/api/v1/getAllItem`,
    saveAsDraftPR: () => `${SERVER_API_URL}/api/v1/saveAsDraftPR`,
    getAllDraftPRs: () => `${SERVER_API_URL}/api/v1/getAllDraftPRs`,
    getEmployeebranchById: (id: any) =>
      `${SERVER_API_URL}/api/v1/getAllCompanyBranchByEmployee/${id}`,
    getAlldepartmentById: (id: any) =>
      `${SERVER_API_URL}/api/v1/getAllDepartment/${id}`,
    getAllProjectById: (id: any) =>
      `${SERVER_API_URL}/api/v1/getAllClientProject/${id}`,
    getClientProject: (id: any) =>
      `${SERVER_API_URL}/api/v1/getAllClientProject/${id}`,
    getAllAssetClassById: (id: any) =>
      `${SERVER_API_URL}/api/v1/getAllAssetClass/${id}`,
    getAllAssetCategory: (id: any) =>
      `${SERVER_API_URL}/api/v1/getAssetCategoryByCompanyId/${id}`,
    getServiceCategory: (id: any) =>
      `${SERVER_API_URL}/api/v1/getServiceCategory/${id}`,
    getItemListByID: (id: any, id1: any) =>
      `${SERVER_API_URL}/api/v1/getItemByClassCategoryId/${id}/${id1}`,
    getItemRegionByClassCategoryId: (id: any, id1: any, region: any) =>
      `${SERVER_API_URL}/api/v1/getItemRegionByClassCategoryId/${id}/${id1}/${region}`,
    createAssetClass: () => `${SERVER_API_URL}/api/v1/createPR`,
    getAllPurchaseRequest: () => `${SERVER_API_URL}/api/v1/getAllPR`,
    approvePurchaseRequest: (purchaseRequest_id: any) =>
      `${SERVER_API_URL}/api/v1/approvePR/${purchaseRequest_id}`,
    getBudgetLeft: (id: any, type: any) =>
      `${SERVER_API_URL}/api/v1/getAllBudget/${id}/${type}`,
    getStatebyCountry: (id: any) =>
      `${SERVER_API_URL}/api/v1/getStateByCountryId/${id}`,
    getCitybystate: (id: any) =>
      `${SERVER_API_URL}/api/v1/getCityByStateId/${id}`,
    getBranchByempId: (id: any) =>
      `${SERVER_API_URL}/api/v1/getAllCompanyBranchByEmployee/${id}`,
    getAllServiceByCategoryId: (id: any) =>
      `${SERVER_API_URL}/api/v1/getAllServiceByCategory/${id}`,
    getLevelWiseData: () => `${SERVER_API_URL}/api/v1/getLevelWiseItemQuantity`,
    getRemainingBudget: () => `${SERVER_API_URL}/api/v1/getRemainingBudget`,
    checkPrWorkflow: () => `${SERVER_API_URL}/api/v1/checkPrWorkflow`,
    checkWorkFlow: () => `${SERVER_API_URL}/api/v1/checkForWorkflowInPr`,
    checkbudgetIncrease: () => `${SERVER_API_URL}/api/v1/updateItemBudgetInPr`,
    getAllItemdata: () => `${SERVER_API_URL}/api/v1/getAllItemdata`,
    getCountPR: (id: any, company_id: any) =>
      `${SERVER_API_URL}/api/v1/getCountPR/${id}/${company_id}`,
    getServiceBudget: (id: any, department_id: any, clientProject_id: any) =>
      `${SERVER_API_URL}/api/v1/getServiceBudget/${id}/${department_id}/${clientProject_id}`,
    getBestVendor: () => `${SERVER_API_URL}/api/v1/getBestVendor`,
    getCountryByBranch: (companyBranchId: any) =>
      `${SERVER_API_URL}/api/v1/getCountryByBranchId/${companyBranchId}`,

    checkPRInsight: () => `${SERVER_API_URL}/api/v1/checkPRInsight`,
  },
  pending: {
    getPendingPR: () => `${SERVER_API_URL}/api/v1/getByApprovalStatus`,
    getPRById: () => `${SERVER_API_URL}/api/v1/getPRById`,
    getItemByid: (id: any) => `${SERVER_API_URL}/api/v1/getItemById/${id}`,
    approvePr: (id: any, id1: any) =>
      `${SERVER_API_URL}/api/v1/updatePrLevelStatus/${id}/${id1}`,

    getPendingPRPO: (company_id: any) =>
      `${SERVER_API_URL}/api/v1/allPending/${company_id}`,
  },

  approved: {
    getApprovedPR: () => `${SERVER_API_URL}/api/v1/getByApprovalStatus`,
  },
};

@Injectable({
  providedIn: 'root',
})
export class PurchaseRequestService {
  constructor(private http: HttpClient) { }

  getAllItem(): Observable<any> {
    return this.http.get<any>(routes.mypr.getAllItem(), {
      observe: 'response',
    });
  }
  getEmployeeBranch(id: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getEmployeebranchById(id), {
      observe: 'response',
    });
  }
  getAllDepartment(id: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getAlldepartmentById(id), {
      observe: 'response',
    });
  }
  getAllProjectById(id: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getAlldepartmentById(id), {
      observe: 'response',
    });
  }
  getClientProject(id: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getClientProject(id), {
      observe: 'response',
    });
  }
  getAllAssetClass(id: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getAllAssetClassById(id), {
      observe: 'response',
    });
  }
  getAllAssetCategory(id: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getAllAssetCategory(id), {
      observe: 'response',
    });
  }

  getServiceCategory(id: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getServiceCategory(id), {
      observe: 'response',
    });
  }

  getAllItemList(id: any, id1: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getItemListByID(id, id1), {
      observe: 'response',
    });
  }
  getItemRegionByClassCategoryId(
    id: any,
    id1: any,
    region: any,
  ): Observable<any> {
    return this.http.get<any>(
      routes.mypr.getItemRegionByClassCategoryId(id, id1, region),
      { observe: 'response' },
    );
  }

  createPR(data: any): Observable<any> {
    return this.http.post<any>(routes.mypr.createAssetClass(), data, {
      observe: 'response',
    });
  }

  saveAsDraftPR(data: any): Observable<any> {
    return this.http.post<any>(routes.mypr.saveAsDraftPR(), data, {
      observe: 'response',
    });
  }

  // ✅ Get all draft PRs
  getAllDraftPRs(data: any): Observable<any> {
    return this.http.post<any>(routes.mypr.getAllDraftPRs(), data, {
      observe: 'response',
    });
  }
  getAllPurchaseRequest(data: any): Observable<any> {
    return this.http.post<any>(routes.mypr.getAllPurchaseRequest(), data, {
      observe: 'response',
    });
  }
  approvePurchaseRequest(purchaseRequest_id: any, data: any): Observable<any> {
    return this.http.post<any>(
      routes.mypr.approvePurchaseRequest(purchaseRequest_id),
      data,
      { observe: 'response' },
    );
  }
  getCountryByBranch(companyBranchId: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getCountryByBranch(companyBranchId), {
      observe: 'response',
    });
  }

  checkPRInsight(data: any): Observable<any> {
    return this.http.post<any>(routes.mypr.checkPRInsight(), data, {
      observe: 'response',
    });
  }
  getStateByCountry(id: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getStatebyCountry(id), {
      observe: 'response',
    });
  }
  getCityByState(id: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getCitybystate(id), {
      observe: 'response',
    });
  }
  getBudgetLeft(id: any, type: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getBudgetLeft(id, type), {
      observe: 'response',
    });
  }
  getBranchById(id: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getBranchByempId(id), {
      observe: 'response',
    });
  }
  getAllServiceByCategoryId(id: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getAllServiceByCategoryId(id), {
      observe: 'response',
    });
  }

  getLevelWiseData(data: any): Observable<any> {
    return this.http.post<any>(routes.mypr.getLevelWiseData(), data, {
      observe: 'response',
    });
  }

  getRemainingBudget(data: any): Observable<any> {
    return this.http.post<any>(routes.mypr.getRemainingBudget(), data, {
      observe: 'response',
    });
  }
  checkPrWorkflow(data: any): Observable<any> {
    return this.http.post<any>(routes.mypr.checkPrWorkflow(), data, {
      observe: 'response',
    });
  }

  checkWorkFlowForPR(data: any): Observable<any> {
    return this.http.post<any>(routes.mypr.checkWorkFlow(), data, {
      observe: 'response',
    });
  }

  checkbudgetForIncrease(data: any): Observable<any> {
    return this.http.post<any>(routes.mypr.checkbudgetIncrease(), data, {
      observe: 'response',
    });
  }
  getServiceBudget(
    id: any,
    department_id: any,
    clientProject_id: any,
  ): Observable<any> {
    return this.http.get<any>(
      routes.mypr.getServiceBudget(id, department_id, clientProject_id),
      { observe: 'response' },
    );
  }
  //************* pending PR ************

  getPRById(data: any): Observable<any> {
    return this.http.post<any>(routes.pending.getPRById(), data, {
      observe: 'response',
    });
  }
  getAllItemdata(): Observable<any> {
    return this.http.get<any>(routes.mypr.getAllItemdata(), {
      observe: 'response',
    });
  }

  getItemById(id: any): Observable<any> {
    return this.http.get<any>(routes.pending.getItemByid(id), {
      observe: 'response',
    });
  }

  approvePr(id: any, id1: any, data: any) {
    return this.http.patch<any>(routes.pending.approvePr(id, id1), data, {
      observe: 'response',
    });
  }
  getPendingList(data: any): Observable<any> {
    return this.http.post<any>(routes.pending.getPendingPR(), data, {
      observe: 'response',
    });
  }

  // **************** Approved PR ********************
  getApprovedList(data: any): Observable<any> {
    return this.http.post<any>(routes.approved.getApprovedPR(), data, {
      observe: 'response',
    });
  }
  getCountPr(id: any, cmp_id: any): Observable<any> {
    return this.http.get<any>(routes.mypr.getCountPR(id, cmp_id), {
      observe: 'response',
    });
  }

  getBestVendor(data: any): Observable<any> {
    return this.http.post<any>(routes.mypr.getBestVendor(), data, {
      observe: 'response',
    });
  }

  getPendingPRPO(company_id: any, data: any): Observable<any> {
    return this.http.get<any>(
      routes.pending.getPendingPRPO(company_id),
      data,
    );
  }
}
